<!-- Tweaked from the original idea by Yoichi Kobayashi: https://github.com/ykob/shape-overlays -->
<template lang="pug">
  header#navigation(itemscope itemtype="http://schema.org/WPHeader")
    //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    hamburger-menu
    //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    div.content
      //- Site Navigation
      div.global-menu
        nav.global-menu__wrap(role="navigation" itemscope itemtype="http://schema.org/SiteNavigationElement")
          a.global-menu__item(@click="goToSection('Uno')") Development
          a.global-menu__item(@click="goToSection('Dos')") UX/UI Coding
          a.global-menu__item(@click="goToSection('Tres')") Side Projects
          a.global-menu__item(@click="goToSection('Contact')") Get in touch

      //- Overlay Effect
      svg.shape-overlays(viewBox="0 0 100 100" preserveAspectRatio="none")
        defs
          linearGradient#gradient1(x1="0%" y1="0%" x2="0%" y2="100%")
            stop(offset="0%" stop-color="#00346B")
            stop(offset="100%" stop-color="#001933")
          linearGradient#gradient2(x1="0%" y1="0%" x2="0%" y2="100%")
            stop(offset="0%" stop-color="#110046")
            stop(offset="100%" stop-color="#32004a")
          linearGradient#gradient3(x1="0%" y1="0%" x2="0%" y2="100%")
            stop(offset="0%" stop-color="#07093D")
            stop(offset="100%" stop-color="#141422")
        path.shape-overlays__path
        path.shape-overlays__path
        path.shape-overlays__path
</template>

<script>
import HamburgerMenu from '@/components/HamburgerMenu.vue'
import ease from '@/assets/js/easings.js'

export default {
  name: 'Navigation',

  components: { HamburgerMenu },

  methods: {
    // SPA nav...
    goToSection (sectionID) {
      document.getElementById(sectionID).scrollIntoView()
    }
  },

  mounted () {
    /* eslint-disable */
    class ShapeOverlays {
      constructor(elm) {
        this.elm = elm;
        this.path = elm.querySelectorAll('path');
        this.numPoints = 90;
        this.duration = 900;
        this.delayPointsArray = [];
        this.delayPointsMax = 200;
        this.delayPerPath = 150;
        this.timeStart = Date.now();
        this.isOpened = false;
        this.isAnimating = false;
      }
      toggle() {
        this.isAnimating = true;
        for (var i = 0; i < this.numPoints; i++) {
          this.delayPointsArray[i] = Math.random() * this.delayPointsMax;
        }
        if (this.isOpened === false) {
          this.open();
        } else {
          this.close();
        }
      }
      open() {
        this.isOpened = true;
        this.elm.classList.add('is-opened');
        this.timeStart = Date.now();
        this.renderLoop();
        //
        setTimeout(() => {
          document.querySelector('main').style.opacity = 0;
          document.querySelector('html').style.overflow = 'hidden';
        }, 350)
      }
      close() {
        this.isOpened = false;
        this.elm.classList.remove('is-opened');
        this.timeStart = Date.now();
        this.renderLoop();
        //
        setTimeout(() => {
          document.querySelector('main').style.opacity = 1;
          document.querySelector('html').style.overflowY = 'auto';
        }, 900)
      }
      updatePathClose(time) {
        const points = [];
        for (var i = 0; i < this.numPoints; i++) {
          points[i] = (1 - ease.cubicInOut(Math.min(Math.max(time - this.delayPointsArray[i], 0) / this.duration, 1))) * 100
        }

        let str = '';
        str += (this.isOpened) ? `M 0 0 V ${points[0]}` : `M 0 ${points[0]}`;
        for (var i = 0; i < this.numPoints - 1; i++) {
          const p = (i + 1) / (this.numPoints - 1) * 100;
          const cp = p - (1 / (this.numPoints - 1) * 100) / 2;
          str += `C ${cp} ${points[i]} ${cp} ${points[i + 1]} ${p} ${points[i + 1]} `;
        }
        str += (this.isOpened) ? `V 100 H 0` : `V 0 H 0`;
        return str;
      }
      updatePathOpen(time) {
        const points = [];
        for (var i = 0; i < this.numPoints; i++) {
          points[i] = ease.cubicInOut(Math.min(Math.max(time - this.delayPointsArray[i], 0) / this.duration, 1)) * 100
        }

        let str = '';
        str += (this.isOpened) ? `M 0 0 V ${points[0]} ` : `M 0 ${points[0]} `;
        for (var i = 0; i < this.numPoints - 1; i++) {
          const p = (i + 1) / (this.numPoints - 1) * 100;
          const cp = p - (1 / (this.numPoints - 1) * 100) / 2;
          str += `C ${cp} ${points[i]} ${cp} ${points[i + 1]} ${p} ${points[i + 1]} `;
        }
        str += (this.isOpened) ? `V 0 H 0` : `V 100 H 0`;
        return str;
      }
      render() {
        if (this.isOpened) {
          for (var i = 0; i < this.path.length; i++) {
            this.path[i].setAttribute('d', this.updatePathOpen(Date.now() - (this.timeStart + this.delayPerPath * i)));
          }
        } else {
          for (var i = 0; i < this.path.length; i++) {
            this.path[i].setAttribute('d', this.updatePathClose(Date.now() - (this.timeStart + this.delayPerPath * (this.path.length - i - 1))));
          }
        }
      }
      renderLoop() {
        this.render();
        if (Date.now() - this.timeStart < this.duration + this.delayPerPath * (this.path.length - 1) + this.delayPointsMax) {
          requestAnimationFrame(() => {
            this.renderLoop();
          });
        }
        else {
          this.isAnimating = false;
        }
      }
    }

    (function() {
      const elmToggle = document.querySelector('#navigation');
      const elmHamburger = document.querySelector('.hamburger');
      const gNavItems = document.querySelectorAll('.global-menu__item');
      const elmOverlay = document.querySelector('.shape-overlays');
      const overlay = new ShapeOverlays(elmOverlay);

      elmToggle.addEventListener('click', () => {
        if (overlay.isAnimating) {
          return false;
        }
        overlay.toggle();
        //
        if (overlay.isOpened === true) {
          elmHamburger.classList.add('is-opened-navi');
          for (var i = 0; i < gNavItems.length; i++) {
            gNavItems[i].classList.add('is-opened');
          }
        } else {
          elmHamburger.classList.remove('is-opened-navi');
          for (var i = 0; i < gNavItems.length; i++) {
            gNavItems[i].classList.remove('is-opened');
          }
        }
      });
    }());
  } // mounted()
}
</script>



<style lang="sass" scoped>
  #navigation
    position: absolute
    top: 0
    left: 0
    width: 100%
    display: flex
    align-items: center
    justify-content: space-between
    backface-visibility: hidden
    .content
      justify-content: center
      min-height: 100vh
      margin: 0 auto
      pointer-events: none
      // Main menu
      .global-menu
        width: 100vw
        height: 100vh
        display: flex
        justify-content: center
        align-items: center
        position: fixed
        top: 0
        left: 0
        z-index: 100
      // SVG Overlay FX
      .shape-overlays
        width: 100vw
        height: 100vh
        pointer-events: none
        position: fixed
        top: 0
        left: 0
        .is-opened
          pointer-events: auto
        // Cooolors
        &__path:nth-of-type(1)
          fill: var(--path-fill-1)
        &__path:nth-of-type(2)
          fill: var(--path-fill-2)
        &__path:nth-of-type(3)
          fill: var(--path-fill-3)
        // &__path:nth-of-type(4)
        //   fill: var(--path-fill-4)

</style>







<style lang="scss" scoped>

#navigation {
  --path-fill-1: url(#gradient1);
	--path-fill-2: url(#gradient2);
	--path-fill-3: url(#gradient3);
  // --color-about: #F8E81C;
  // --color-works: #64ED0C;
  // --color-contact: #F6A623;

  --color-about:    #F2E059;
  --color-works:    #F2E059;
  --color-contact:  #F2E059;
}


.global-menu__item {
	color: white;
	font-family: inherit;
	font-size: 2.75rem;
	font-weight: 800;
  letter-spacing: 0.05em;
	opacity: 0;
	transform: translateY(100%);
	pointer-events: none;
	display: block;
	margin: 0.75em 0;
	transition: transform 0.3s, opacity 0.3s;
	transition-timing-function: ease-in;
  @media screen and (min-width: 35.5em) {
    font-size: 4rem;
  }
  &:nth-of-type(1) {
    transition-delay: 0.25s;
  }
  &:nth-of-type(2) {
    transition-delay: 0.2s;
  }
  &:nth-of-type(3) {
    transition-delay: 0.15s;
  }
  &:nth-of-type(4) {
    transition-delay: 0.1s;
  }

  // &:nth-child(1) {
  //   &:hover {
  //     text-shadow:
  //       3px 3px 0 var(--color-about),
  //       -1px -1px 0 var(--color-about),
  //       1px -1px 0 var(--color-about),
  //       -1px 1px 0 #000,
  //       1px 1px 0 #000;
  //   }
  //   &:after {
  //     background-color: var(--color-about);
  //   }
  // }
  // &:nth-child(2) {
  //   &:hover {
  //     text-shadow:
  //       3px 3px 0 var(--color-works),
  //       -1px -1px 0 var(--color-works),
  //       1px -1px 0 var(--color-works),
  //       -1px 1px 0 var(--color-works),
  //       1px 1px 0 var(--color-works);
  //   }
  //   &:after {
  //     background-color: var(--color-works);
  //   }
  // }
  // &:nth-child(3), &:nth-child(4) {
  //   &:hover {
  //     text-shadow:
  //       3px 3px 0 var(--color-contact),
  //       -1px -1px 0 var(--color-contact),
  //       1px -1px 0 var(--color-contact),
  //       -1px 1px 0 #000,
  //       1px 1px 0 #000;
  //   }
  //   &:after {
  //     background-color: var(--color-contact);
  //   }
  // }

  &:before {
    position: absolute;
    content: '';
    width: 0%;
    height: 4px;
    bottom: -5px;
    left: 0;
    background-image: url('../../assets/images/nav-hover-eff.svg');
    background-repeat: repeat-x;
    z-index: 10;
    transition: all 0.5s ease;
  }
  &:hover {
    &:before {
      width: 14%
    }
  }

  // Opened
  &.is-opened {
    opacity: 1;
    transform: translateY(0) rotate(0);
    pointer-events: auto;
    cursor: pointer;
    transition-timing-function: ease;
    transition-duration: 0.8s;
    &:nth-of-type(1) {
    transition-delay: 1s;
    }
    &:nth-of-type(2) {
      transition-delay: 1.1s;
    }
    &:nth-of-type(3) {
      transition-delay: 1.2s;
    }
    &:nth-of-type(4) {
      transition-delay: 1.3s;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/core/Navigation.vue